import * as React from 'react';

import { cn } from '@/lib/utils';

interface DetailsListFiltersBarProps {
	children: React.ReactNode;
	className?: string;
	contentClassName?: string;
}

interface DetailsListFiltersSeparatorProps {
	className?: string;
}

interface DetailsListFiltersSpacerProps {
	className?: string;
}

export function DetailsListFiltersBar({
	children,
	className,
	contentClassName
}: DetailsListFiltersBarProps) {
	return (
		<div
			className={cn(
				'mb-3 pb-2 border-b border-gray-200 dark:border-slate-700',
				className
			)}
		>
			<div
				className={cn(
					'flex w-full items-center gap-2 [&>*]:min-w-0 [&>*]:self-center',
					contentClassName
				)}
			>
				{children}
			</div>
		</div>
	);
}

export function DetailsListFiltersSeparator({
	className
}: DetailsListFiltersSeparatorProps) {
	return (
		<div
			aria-hidden="true"
			className={cn('w-px h-5 shrink-0 bg-border', className)}
		/>
	);
}

export function DetailsListFiltersSpacer({
	className
}: DetailsListFiltersSpacerProps) {
	return <div aria-hidden="true" className={cn('flex-1 min-w-0', className)} />;
}
